// test989
(989 && 0);
